/**
 * Icone de de alerta critico
 * @param {number} number - O número a ser exibido no ícone.
 * @returns {ReactComponentElement} 
 */
const CriticoIcon = ({ number, width, height, fill, className }) => {
    return (
        <svg className={className} width={width ? width : '20'} height={height ? height : '20'} viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.2543 3.53092C13.3631 1.61209 16.133 1.61209 17.2418 3.53092L28.3574 22.7672C29.4669 24.6873 28.0812 27.0883 25.8636 27.0883H3.63245C1.41487 27.0883 0.0292398 24.6873 1.13874 22.7672L12.2543 3.53092Z" fill={fill ? fill : "#FF3939"}/>
            <text x="14" y="20" textAnchor="middle" fontSize="15" fill="#FFFFFF" fontFamily="Segoe UI, sans-serif">{number}</text>
        </svg>

    );
}

export default CriticoIcon;